import React, { useEffect, useState, useCallback } from "react";
import _ from 'lodash';
import { Space, Button } from 'antd';
import { ArrowLeft } from "react-bootstrap-icons";

import BaseTable from "components/BaseTable";
import editIcon from "components/Dashboard/assets/edit-icon.svg";
import DeleteModal from "components/Dashboard/OverviewComponents/DeleteModal";
import InnerLoading from "components/InnerLoading";
import plusIcon from "components/Dashboard/assets/plus-icon.svg";
import RepeatableRoomModal from "components/RepeatableRoomTemplate/RepeatableRoomTemplateModal";

import {
    fetchRepeatableRoomTemplate,
    deleteRepeatableRoomTemplate,
    createRepeatableRoomTemplate,
    updateRepeatableRoomTemplate
} from "services/section";

export default function RepeatableRoomTemplateList({section, handleBack}) {
    const [rows, setRows] = useState();
    const [totalCount, setTotalCount] = useState(0);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [params, setParams] = useState({});
    const [currentRoomTemplate, setCurrentRoomTemplate] = useState(null);
    
    const [openModal, setOpenModal] = useState(false);
    const [openDeleteModal, setOpenDeleteModal] = useState(false);
    const [loading, setLoading] = useState(false);

    const cols = [
        {
            title: 'Name',
            dataIndex: 'name',
            sorter : true
        },
        {
            title: 'Action',
            key: 'action',
            sorter: false,
            render: (row) => (
              <Space size="middle">
                <Button variant="info" size="sm" onClick={() => handleEdit(row)}>
                    <img src={editIcon} alt="" className="image-responsive" />
                </Button>
                <Button variant="info" size="sm" onClick={() => onDelete(row)}>
                    <i className="fa-sharp fa-solid fa-trash"></i>
                </Button>
              </Space>
            ),
          },
    ]
    const fetchData = useCallback(async () => {
        setLoading(true);
        if (!_.isEmpty(section)) {
            const response = await fetchRepeatableRoomTemplate(section.id, page, pageSize);
            setTotalCount(response.count)
            setRows(response.results)
        }
        setLoading(false);
    }, [page, pageSize, section]);

    const handleCreate = () => {
        setCurrentRoomTemplate(null)
        setOpenModal(true)
    }
    const handleEdit = (row) => {
        setCurrentRoomTemplate(row)
        setOpenModal(true)
    }
    const handleDelete = async () => {
       await deleteRepeatableRoomTemplate(currentRoomTemplate.id);
       const newRows = rows.filter(item => item.id != currentRoomTemplate.id);
       setRows(newRows);
       setOpenDeleteModal(false);
    }
    const onDelete = (row) => {
        setCurrentRoomTemplate(row)
        setOpenDeleteModal(true)
    }

    const handleSubmit = async (id=null, payload) => {
        if(id) {
            const response = await updateRepeatableRoomTemplate(id, payload);
            let index = rows.findIndex(item => item.id == response.id);
            let newRows = rows;
            newRows[index] = {...newRows[index], ...response}
            setRows(newRows);
        } else {
            const response = await createRepeatableRoomTemplate(payload);
            let newRows = [...rows, response];
            setRows(newRows);
        }
        setOpenModal(false);
    }

    useEffect(() => {
        fetchData();
    }, [section]);

    const handleFetch = (currentPage, currentPageSize, currentParams) => {
        setPage(currentPage);
        setPageSize(currentPageSize);
        setParams(currentParams);
    }

    return (
        <>
            <InnerLoading show={loading} />
            <div className="d-flex justify-content-between py-3">
                <button
                    className="btn btn-outline-secondary shadow-none"
                    onClick={handleBack}
                >
                    <ArrowLeft />
                </button>
                {!_.isEmpty(section) && <button
                    className="btn btn-outline-secondary shadow-none"
                    onClick={handleCreate}
                >
                    <img src={plusIcon} alt="" className="mr5 image-responsive" />
                    <span>Create repeatable room template</span>
                </button>}
            </div>

            <BaseTable 
                cols={cols}
                rows={rows}
                totalCount={totalCount}
                getData={handleFetch}
            />
            <RepeatableRoomModal 
                repeatableRoomTemplate={currentRoomTemplate}
                section={section}
                open={openModal}
                handleSubmit={handleSubmit}
                onCloseModal={() => setOpenModal(false)}
            />
            <DeleteModal loading={loading} 
            open={openDeleteModal}
            onCloseModal={() => setOpenDeleteModal(false)}
            message="Room Template"
            onDelete={handleDelete}/>
        </>
    );
}
